import { ServiceMaker, methods, services } from "../services";

export const fetchBulkNotificationList = (payload) =>
  ServiceMaker(
    `/batch-processor/bulk-notification/list?status=${payload.status}&fromDate=${payload.fromDate}&toDate=${payload.toDate}&page=${payload.page}&limit=${payload.limit}`,
    methods.GET,
    services.master,
  );

export const updateApprovalNoti  = (payload) =>
  ServiceMaker(
    `/batch-processor/bulk-notification/approval/${payload.id}`,
    methods.PUT,
    services.master,
    payload
  );
export const fetchBulkNotificationDetails  = (payload) =>
  ServiceMaker(
    `/batch-processor/bulk-notification/details/${payload}`,
    methods.GET,
    services.master
  );
